var React = require('react');

function CreditCard (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M22,9 L22,6 C22,5.44771525 21.5522847,5 21,5 L3,5 C2.44771525,5 2,5.44771525 2,6 L2,9 L22,9 Z M22,11 L2,11 L2,18 C2,18.5522847 2.44771525,19 3,19 L21,19 C21.5522847,19 22,18.5522847 22,18 L22,11 Z M3,3 L21,3 C22.6568542,3 24,4.34314575 24,6 L24,18 C24,19.6568542 22.6568542,21 21,21 L3,21 C1.34314575,21 2.22044605e-16,19.6568542 0,18 L0,6 C-2.22044605e-16,4.34314575 1.34314575,3 3,3 Z"}));
}

CreditCard.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CreditCard;

CreditCard.default = CreditCard;
